import AdminDashboard from "../index";

function Init() {
  return <AdminDashboard />;
}

export default Init;
